import Provider from './bookingProvider'

export default class {
  constructor (camping) {
    this.startYear = camping.startYear // année du 1er abonnement
    if (camping.provider !== null) {
      this.provider = new Provider(camping.provider) // infos sur le provider
    } else {
      this.provider = null
    }
  }
}
